// @flow

import {LocalStorageItem} from './LocalStorageItem';
import MANIFEST from '../../../localStorage.yaml';

const items = Object.keys(MANIFEST).reduce((hash, name) => {
  hash[name] = new LocalStorageItem(name, MANIFEST[name]);
  return hash;
}, {});

const inexactItems = Object.keys(items)
  .filter((name) => items[name].inexact)
  .map((name) => items[name]);

/**
 * Contains information about all known local storage items, loaded from
 * pay-server/cookies/localStorage.yaml. Only items which have entries in the
 * manifest are allowed to be set.
 * @private
 */
export const LocalStorageManifest = {
  /**
   * Gets the LocalStorageItem definition for the specified item from the manifest.
   * If no matching item exists, throws an error.
   * @param {string} name The name of the item to retrieve.
   */
  get(name: string): LocalStorageItem {
    // First, try to match the item's name exactly.
    if (items[name]) return items[name];

    // If we didn't find an exact match, try to match by pattern instead.
    for (const item of inexactItems) {
      if (item.isMatch(name)) return item;
    }

    // If we couldn't find a match, throw an error.
    throw new Error(
      `No localStorage item matching the name ${name} was found in the manifest. ` +
        `If you're adding a new localStorage item, please visit go/cookies for more information!`,
    );
  },
};
